module.exports = __webpack_public_path__ + "img/Paytm_Money_Logo.06293ed6.png";